import { configureStore  } from '@reduxjs/toolkit'
import MOTDSlice from './features/MOTD/MOTDSlice'
import { Streamware } from './middleware/Streamware'
import ProjectSlice from './features/Project/ProjectSlice'
import WaypointSlice from './features/Waypoint/WaypointSlice'
import PhaseSlice from './features/Phases/PhaseSlice'
import ActionSlice from './features/Actions/ActionSlice'
import UserSlice from './features/Users/UsersSlice'
import ConnectionSlice  from './features/Connection/ConnectionSlice'
import ConfigSlice from './features/Sensors/ConfigSlice'
import MeasurementsSlice from './features/Measurements/MeasurementSlice'
import goBackSlice from './features/GoBack/GoBackSlice'
import AggregateSlice from './features/Aggregate/AggregateSlice'


export const store = configureStore({
  reducer: {
    MOTD: MOTDSlice,
    Waypoint: WaypointSlice,
    Projects: ProjectSlice,
    Phases:PhaseSlice,
    Actions:ActionSlice,
    Users:UserSlice,
    Connection:ConnectionSlice,
    Config:ConfigSlice,
    Measurements:MeasurementsSlice,
    GoBack:goBackSlice,
    Aggregate:AggregateSlice
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat([Streamware])
  },
  
})

// Get the type of our store variable
export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']